export const AP_RPE_MODULE_NAMES = [
  'Account Payable',
  'Accounts Payable',
] as const;

export const AP_RPE_MODULE = AP_RPE_MODULE_NAMES[0];

/** API actionName values (case-insensitive match in UserEffectivePermissionsService). */
export const AP_RPE_ACTION_PUBLISH_TO_GP = 'publish to gp';
export const AP_RPE_ACTION_REPUBLISH_TO_GP = 'republish to gp';
export const AP_RPE_ACTION_DOWNLOAD_CHARGE_SHEET = 'download charge sheet';
export const AP_RPE_ACTION_DOWNLOAD_AP_INVOICES = 'download ap invoices';
/** UI: Override AP Invoice Date Limits */
export const AP_RPE_ACTION_OVERRIDE_INVOICE_DATE_LIMITS =
  'override ap invoice date limits';
